<template>
  <div class="settings">
    <div class="modal-mask">
      <div class="modal-wrapper" @click.self="$emit('close')">
        <div class="modal-container">
          <h3>Settings</h3>
          <table>
            <tr>
              <td>Density</td>
              <td>
                <select @change="updateDensity($event.target.value)">
                  <option :selected="density === 'mobile'" value="mobile">Mobile</option>
                  <option :selected="density === 'desktop'" value="desktop">Desktop</option>
                </select>
              </td>
            </tr>
            <tr>
              <td colspan=2><button @click="$emit('saveTasks')">Download tasks</button></td>
            </tr>
          </table>
          <button class="ok-button" @click="$emit('close')">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'settings',

  data () {
    return {
      density: localStorage.getItem('settings.density')
    }
  },

  methods: {
    updateDensity: function (density) {
      localStorage.setItem('settings.density', density)
    }
  },

  beforeCreate () {
    if (localStorage.getItem('settings.density') === null) {
      localStorage.setItem('settings.density', 'desktop')
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 5;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

h3 {
  margin-top: 0;
}

.ok-button {
  margin-top: 1em;
}
</style>
